import Input from '@/components/ui/forms/input';
import { Controller, useFormContext } from 'react-hook-form';

import { Fieldset } from '../fields';
import { maskCpf, maskPhone, maskRg } from '../masks';
import type { DeliveryPartnerFormValues } from '../schema';

export default function StepDadosPessoais() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<DeliveryPartnerFormValues>();

  return (
    <Fieldset
      legend="Dados pessoais"
      description="Usamos estes dados para identificar você e entrar em contato sobre a candidatura."
    >
      <div className="grid gap-5 sm:grid-cols-2">
        <Input
          label="Nome"
          required
          placeholder="João"
          {...register('first_name')}
          error={errors.first_name?.message}
        />
        <Input
          label="Sobrenome"
          required
          placeholder="Silva"
          {...register('last_name')}
          error={errors.last_name?.message}
        />

        <Controller
          name="cpf"
          control={control}
          render={({ field }) => (
            <Input
              label="CPF"
              required
              inputMode="numeric"
              placeholder="000.000.000-00"
              name={field.name}
              ref={field.ref}
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onChange={(event) => field.onChange(maskCpf(event.target.value))}
              error={errors.cpf?.message}
            />
          )}
        />

        <Controller
          name="rg"
          control={control}
          render={({ field }) => (
            <Input
              label="RG"
              placeholder="00.000.000-0"
              name={field.name}
              ref={field.ref}
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onChange={(event) => field.onChange(maskRg(event.target.value))}
              error={errors.rg?.message}
            />
          )}
        />

        <Controller
          name="phone"
          control={control}
          render={({ field }) => (
            <Input
              label="Telefone / WhatsApp"
              required
              type="tel"
              inputMode="numeric"
              placeholder="(11) 99999-9999"
              name={field.name}
              ref={field.ref}
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onChange={(event) =>
                field.onChange(maskPhone(event.target.value))
              }
              error={errors.phone?.message}
            />
          )}
        />

        <Input
          label="E-mail"
          required
          type="email"
          inputMode="email"
          placeholder="voce@email.com"
          {...register('email')}
          error={errors.email?.message}
        />

        <Input
          label="Data de nascimento"
          required
          type="date"
          {...register('birth_date')}
          error={errors.birth_date?.message}
        />
      </div>
    </Fieldset>
  );
}
